import React, { useState, useEffect } from "react"
import { Box, Fab, Button } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

interface LivisFloatingButtonProps {
  icon: React.ReactNode
  label?: string
  options?: {
    label: string
    onClick: () => void
  }[]
  onMainClick?: () => void
  position?: {
    bottom?: number
    right?: number
  }
  blurredBackground?: boolean
  zIndex?: number
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

const LivisFloatingButton: React.FC<LivisFloatingButtonProps> = ({
  icon,
  label = "Action",
  options = [],
  onMainClick,
  position = { bottom: 50, right: 92 },
  blurredBackground = true,
  zIndex = 99,
  isOpen,
  onOpen,
  onClose,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  // const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("livis-tour-open")
    } else {
      document.body.classList.remove("livis-tour-open")
    }
    return () => {
      document.body.classList.remove("livis-tour-open")
    }
  }, [isOpen])

  const handleFabClick = () => {
    if (options.length > 0) {
      //   setIsOpen(true);
      onOpen()
    } else if (onMainClick) {
      onMainClick()
    }
  }

  const handleClose = () => {
    //  setIsOpen(false);
    onClose()
  }

  return (
    <Box className="floating-button-container">
      {/* Background Blur Layer */}
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          right: 0,
          width: "400px",
          height: "400px",
          background: "rgba(0, 0, 0, 0.4)",
          borderRadius: "380px 0 0 0",
          transition: "opacity 0.3s ease",
          opacity: isOpen ? 1 : 0,
          backdropFilter: blurredBackground ? "blur(4px)" : "none",
          pointerEvents: "none",
          zIndex,
        }}
      />

      {isOpen ? (
        // Open State with Options
        <Box className="tour-options-wrapper">
          {options.map((opt, index) => (
            <Button
              key={index}
              variant="contained"
              className="tour-option-button"
              onClick={opt.onClick}
            >
              {opt.label}
            </Button>
          ))}

          <Fab
            className="tour-close-button"
            aria-label="close tour options"
            onClick={(e) => {
              e.stopPropagation()
              handleClose()
            }}
          >
            <CloseIcon />
          </Fab>
        </Box>
      ) : (
        // Default Floating Button
        <Fab
          className={`floating-button-fab ${
            isHovered ? "floating-button-fab-hovered" : ""
          }`}
          aria-label={label}
          sx={{
            position: "fixed",
            bottom: position.bottom,
            right: position.right,
            zIndex: zIndex + 1,
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleFabClick}
        >
          {isHovered && <span className="floating-button-text">{label}</span>}
          <Box className="floating-button-icon">{icon}</Box>
        </Fab>
      )}
    </Box>
  )
}

export default LivisFloatingButton
